import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.5 1.5H10.3548V4.14012H4.14012V10.3548H1.5V1.5ZM7.76008 10.5C7.25806 10.5 6.79536 10.376 6.37198 10.128C5.94859 9.88004 5.6129 9.54435 5.36492 9.12097C5.11694 8.70363 4.99294 8.24395 4.99294 7.74194C4.99294 7.24597 5.11694 6.78931 5.36492 6.37198C5.6129 5.94859 5.94859 5.6129 6.37198 5.36492C6.79536 5.11694 7.25806 4.99294 7.76008 4.99294C8.25605 4.99294 8.7127 5.11694 9.13004 5.36492C9.54738 5.6129 9.88004 5.94859 10.128 6.37198C10.376 6.78931 10.5 7.24597 10.5 7.74194C10.5 8.24395 10.376 8.70363 10.128 9.12097C9.88004 9.54435 9.54738 9.88004 9.13004 10.128C8.7127 10.376 8.25605 10.5 7.76008 10.5Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 2H13.8065V5.52016H5.52016V13.8065H2V2ZM10.3468 14C9.67742 14 9.06048 13.8347 8.49597 13.504C7.93145 13.1734 7.48387 12.7258 7.15323 12.1613C6.82258 11.6048 6.65726 10.9919 6.65726 10.3226C6.65726 9.66129 6.82258 9.05242 7.15323 8.49597C7.48387 7.93145 7.93145 7.48387 8.49597 7.15323C9.06048 6.82258 9.67742 6.65726 10.3468 6.65726C11.0081 6.65726 11.6169 6.82258 12.1734 7.15323C12.7298 7.48387 13.1734 7.93145 13.504 8.49597C13.8347 9.05242 14 9.66129 14 10.3226C14 10.9919 13.8347 11.6048 13.504 12.1613C13.1734 12.7258 12.7298 13.1734 12.1734 13.504C11.6169 13.8347 11.0081 14 10.3468 14Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.5 2.5H17.2581V6.9002H6.9002V17.2581H2.5V2.5ZM12.9335 17.5C12.0968 17.5 11.3256 17.2933 10.62 16.88C9.91431 16.4667 9.35484 15.9073 8.94153 15.2016C8.52823 14.506 8.32157 13.7399 8.32157 12.9032C8.32157 12.0766 8.52823 11.3155 8.94153 10.62C9.35484 9.91431 9.91431 9.35484 10.62 8.94153C11.3256 8.52823 12.0968 8.32157 12.9335 8.32157C13.7601 8.32157 14.5212 8.52823 15.2167 8.94153C15.9123 9.35484 16.4667 9.91431 16.88 10.62C17.2933 11.3155 17.5 12.0766 17.5 12.9032C17.5 13.7399 17.2933 14.506 16.88 15.2016C16.4667 15.9073 15.9123 16.4667 15.2167 16.88C14.5212 17.2933 13.7601 17.5 12.9335 17.5Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.5 1.5H10.3548V4.14012H4.14012V10.3548H1.5V1.5ZM7.76008 10.5C7.25806 10.5 6.79536 10.376 6.37198 10.128C5.94859 9.88004 5.6129 9.54435 5.36492 9.12097C5.11694 8.70363 4.99294 8.24395 4.99294 7.74194C4.99294 7.24597 5.11694 6.78931 5.36492 6.37198C5.6129 5.94859 5.94859 5.6129 6.37198 5.36492C6.79536 5.11694 7.25806 4.99294 7.76008 4.99294C8.25605 4.99294 8.7127 5.11694 9.13004 5.36492C9.54738 5.6129 9.88004 5.94859 10.128 6.37198C10.376 6.78931 10.5 7.24597 10.5 7.74194C10.5 8.24395 10.376 8.70363 10.128 9.12097C9.88004 9.54435 9.54738 9.88004 9.13004 10.128C8.7127 10.376 8.25605 10.5 7.76008 10.5Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 2H13.8065V5.52016H5.52016V13.8065H2V2ZM10.3468 14C9.67742 14 9.06048 13.8347 8.49597 13.504C7.93145 13.1734 7.48387 12.7258 7.15323 12.1613C6.82258 11.6048 6.65726 10.9919 6.65726 10.3226C6.65726 9.66129 6.82258 9.05242 7.15323 8.49597C7.48387 7.93145 7.93145 7.48387 8.49597 7.15323C9.06048 6.82258 9.67742 6.65726 10.3468 6.65726C11.0081 6.65726 11.6169 6.82258 12.1734 7.15323C12.7298 7.48387 13.1734 7.93145 13.504 8.49597C13.8347 9.05242 14 9.66129 14 10.3226C14 10.9919 13.8347 11.6048 13.504 12.1613C13.1734 12.7258 12.7298 13.1734 12.1734 13.504C11.6169 13.8347 11.0081 14 10.3468 14Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.5 2.5H17.2581V6.9002H6.9002V17.2581H2.5V2.5ZM12.9335 17.5C12.0968 17.5 11.3256 17.2933 10.62 16.88C9.91431 16.4667 9.35484 15.9073 8.94153 15.2016C8.52823 14.506 8.32157 13.7399 8.32157 12.9032C8.32157 12.0766 8.52823 11.3155 8.94153 10.62C9.35484 9.91431 9.91431 9.35484 10.62 8.94153C11.3256 8.52823 12.0968 8.32157 12.9335 8.32157C13.7601 8.32157 14.5212 8.52823 15.2167 8.94153C15.9123 9.35484 16.4667 9.91431 16.88 10.62C17.2933 11.3155 17.5 12.0766 17.5 12.9032C17.5 13.7399 17.2933 14.506 16.88 15.2016C16.4667 15.9073 15.9123 16.4667 15.2167 16.88C14.5212 17.2933 13.7601 17.5 12.9335 17.5Z" fill="currentColor" />
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconFrontLogo: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"front-logo"} {...props} />
);
